
import { PreferencesComponent } from './management/file/preferences/preferences.component';
import { StoreComponent } from './management/main/store/store.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { POSComponent } from './management/pos/pos.component';
import { ManagementComponent } from './management/management.component';
import { HelpComponent } from './management/help/help.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { OauthComponent } from './oauth/oauth.component';
import { NgModule } from '@angular/core';
import { RouterModule, ROUTES, Routes } from '@angular/router';
import { SecurityLevelComponent } from './management/main/security-level/security-level.component';
import { StockComponent } from './management/main/stock/stock.component';
import { checkDomain } from './Classes/checkDomain';
import { AuthGuard } from './auth.guard';
import { LoginGuard } from './login.guard';
import { environment } from 'src/environments/environment';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { SettingsComponent } from './management/settings/settings.component';
import { ReportsComponent } from './management/reports/reports.component';
import { KitchenPrintingComponent } from './management/kitchen-printing/kitchen-printing.component';
import { MiscellaneousComponent } from './management/miscellaneous/miscellaneous.component';
import { CustomerComponent } from './management/main/customer/customer.component';
import { EreceiptComponent } from './ereceipt/ereceipt.component';
import { PermissionGuard } from './services/permission.guard';
import { UnauthorizedComponent } from './management/unauthorized/unauthorized.component';
import { InventoryComponent } from './management/inventory/inventory.component';
import { AuthSubdomainComponent } from './auth-subdomain/auth-subdomain.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
// import { AgentComponent } from './management/agent/agent.component';
import { SupplierComponent } from './management/supplier/supplier.component';
import { EmenuComponent } from './management/emenu/emenu.component';
import { HousekeepingComponent } from './management/housekeeping/housekeeping.component';

const standardRoutes: Routes =
  [
    {
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      path: 'management',
      component: ManagementComponent,
      children: [
        {
          path: 'dashboard',
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'dashboard' },
          loadChildren: () => import('./management/dashboard-v2/dashboard-v2.module').then((m) => m.DashboardV2Module)

        },
        {
          path: 'preferences',
          component: PreferencesComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'preferences' },
          loadChildren: () => import('./management/file/preferences/preferences.module').then((m) => m.PreferencesModule)
        },
        {
          path: 'kitchen-printing',
          component: KitchenPrintingComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'kitchen' },
          loadChildren: () => import('./management/kitchen-printing/kitchen-printing.module').then((m) => m.KitchenPrintingModule)
        },
        {
          path:'store',
          component: StoreComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'store', breadcrumb: 'Store', displaySubMenu: true},
          loadChildren: () => import('./management/main/store/store.module').then((m) => m.StoreModule)
        },
        {
          path: 'security-level',
          component: SecurityLevelComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'employee', breadcrumb: 'User Management', displaySubMenu: true},
          loadChildren: () => import('./management/main/security-level/security-level.module').then((m) => m.SecurityLevelModule)

        },
        {
          path:'stock',
          component: StockComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'stock', breadcrumb: 'Stock', displaySubMenu: true},
          loadChildren: () => import('./management/main/stock/stock.module').then((m) => m.StockModule)
        },
        {
          path: 'condiment',
          component: POSComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'condiment', breadcrumb: 'Condiment'},
          loadChildren: () => import('./management/pos/condiment.module').then((m) => m.CondimentModule)
        },
        {
          path: 'pos',
          component: POSComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'pos', breadcrumb: 'POS'},
          loadChildren: () => import('./management/pos/pos.module').then((m) => m.PosModule)

        },
        {
          path: 'e-menu',
          component: EmenuComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'emenu' },
          loadChildren: () => import('./management/emenu/emenu.module').then((m) => m.EmenuModule)

        },
        // {
        //   path: 'audit', component: EmanagerAuditTrackComponent,
        //   children:
        //     [
        //       { path: 'emanager-audit-track', component: EmanagerAuditTrackComponent },
        //       { path: '', redirectTo: '/management/audit/emanager-audit-track', pathMatch: 'full' },
        //       { path: '**', component: NotFoundComponent }
        //     ]
        // },
        {
          path: 'inventory', component: InventoryComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'inventory', breadcrumb: 'Inventory', displaySubMenu: true},
          loadChildren: () => import('./management/inventory/inventory.module').then((m) => m.InventoryModule)
        },
        { 
          path: 'settings', component: SettingsComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'settings', breadcrumb: 'Settings', displaySubMenu: true},
          loadChildren: () => import('./management/settings/settings.module').then((m) => m.SettingsModule)
        },
        {
          path: 'o-reports',
          component: ReportsComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'reports' },
          loadChildren: () => import('./management/reports/reports.module').then((m) => m.ReportsModule)
        },
        {
          path: 't-reports',
          component: ReportsComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'reports' },
          loadChildren: () => import('./management/reports/reports.module').then((m) => m.ReportsModule)
        },
        {
          path: 'miscellaneous', component: MiscellaneousComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'miscellaneous' },
          loadChildren: () => import('./management/miscellaneous/miscellaneous.module').then((m) => m.MiscModule)
        },
        // {
        //   path: 'voucher-hub', component: VoucherHubComponent,
        //   canActivate: [PermissionGuard],
        //   canLoad: [PermissionGuard],
        //   data: { permission: 'voucher-hub' },
        //   loadChildren: () => import('./management/voucher-hub/voucher-hub.module').then((m) => m.VoucherHubModule)
        // },
        {
          path: 'customer',
          component: CustomerComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'customer', breadcrumb: 'Customer', displaySubMenu: true},
          loadChildren: () => import('./management/main/customer/customer.module').then((m) => m.CustomerModule)
        },
        {
          path: 'supplier',
          component: SupplierComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'supplier', breadcrumb: 'Supplier', displaySubMenu: true},
          loadChildren: () => import('./management/supplier/supplier.module').then((m) => m.SupplierModule)
        },
        {
          path: 'housekeeping',
          component: HousekeepingComponent,
          canActivate: [PermissionGuard],
          canLoad: [PermissionGuard],
          data: { permission: 'housekeeping', breadcrumb: 'Housekeeping', displaySubMenu: true},
          loadChildren: () => import('./management/housekeeping/housekeeping.module').then((m) => m.HousekeepingModule)
        },
        // {
        //   path: 'agent',
        //   component: AgentComponent,
        //   canActivate: [PermissionGuard],
        //   canLoad: [PermissionGuard],
        //   data: { permission: 'agent' },
        //   loadChildren: () => import('./management/agent/agent.module').then((m) => m.AgentModule)
        // },
        {
          path: 'unauthorized',
          component: UnauthorizedComponent
        },
        // { path: 'company-profile', component: CompanyProfileComponent },
        { path: 'help', component: HelpComponent },
        { path: '', redirectTo: '/management/dashboard', pathMatch: 'full' },
        { path: '**', component: NotFoundComponent }
      ]
    },
    // {
    //   path: 'preview',
    //   component: PreviewComponent, // Assuming there's a component for the 'preview' route
    //   children: [
    //     { path: "hoursales", component: HourSalesComponent },
    //     { path: "averagesalessummary", component: AverageSalesSummaryComponent },
    //     { path: "inactivestock", component: InactiveStockComponent },
    //     { path: "receiptanalysis", component: ReceiptAnalysisComponent },
    //     // { path: "storevoucher", component: StoreVoucherComponent },
    //     // { path: "vendorvoucher", component: VendorVoucherComponent },
    //     { path: "solditemanalysis", component: SoldItemAnalysisComponent },
    //     { path: "salesremark", component: SalesRemarkComponent },
    //     { path: "pricelevelshift", component: PriceLevelShiftComponent },
    //     { path: "transactionvoid", component: TransactionVoidComponent },
    //     { path: "operatorcollection", component: OperatorCollectionComponent },
    //     { path: "transactionDetails", component: TransactionDetailsComponent },
    //     { path: "terminalCollection", component: TerminalCollectionComponent },
    //     { path: "taxTransaction", component: TaxTransactionComponent },
    //     { path: "paymentType", component: PaymentTypeComponent },
    //     { path: "skuSales", component: SkuSalesComponent },
    //     { path: "groupSales", component: GroupSalesComponent },
    //     { path: "departmentSales", component: DepartmentSalesComponent },
    //     { path: "transactionSales", component: TransactionSalesComponent },
    //     { path: "categorySales", component: CategorySalesComponent },
    //     // Other child routes if any
    //   ]
    // },
    // {
    //   path: 'ereceipt',
    //   component: EreceiptComponent, 
    // },
    { path: '**', component: NotFoundComponent },
  ];

@NgModule({
  imports: [RouterModule.forRoot([])],
  exports: [RouterModule],
  providers: [
    {
      provide: ROUTES,
      useFactory: () => {
        let routes: Routes = [];

        routes.push(
          { path: 'oauthcallback', component: OauthComponent },
          { path: 'maintenance', component: MaintenanceComponent },
        );
        if (checkDomain() === environment.ROUTING_NAME || checkDomain() === environment.DOMAIN){
          routes.push(
            {
              path: 'auth-tenant', component: AuthSubdomainComponent,
            },
            { path: '', redirectTo: '/auth-tenant', pathMatch: 'full' },
            { path: '**', redirectTo: '/auth-tenant', pathMatch: 'full'  },
          );
          return [
            ...routes
          ];
        }
        else {
          routes.push(
            {
              path: 'ereceipt',
              component: EreceiptComponent
            },
            {
              path: 'login', component: LoginComponent,
              canActivate: [LoginGuard],

            },
            { path: '', redirectTo: '/login', pathMatch: 'full' },
            { path: 'forgotpassword', component: ForgotpasswordComponent },
          );
            
          return [
            ...routes,
            ...standardRoutes
          ];
        }
        

        // if (Math.random() < 0.5) {
        //   routes.push({
        //     path: 'secret',
        //     component: TopSecretComponent
        //   });
        // }

      },
      multi: true
    }
  ]
})
export class AppRoutingModule { }
